import { ReactNode, forwardRef } from 'react';

import { formatHotkey } from '../../utils/format-hotkey';

import styles from './KeyboardShortcut.module.css';

type KeyboardShortcutProps = {
  hotkey?: string;
  children?: ReactNode;
};

export const KeyboardShortcut = forwardRef<
  HTMLSpanElement,
  KeyboardShortcutProps
>(({ hotkey, children }, ref) => {
  const data = typeof children === 'string' ? children : hotkey;

  return (
    <span ref={ref} className={styles.root}>
      {formatHotkey(data)}
    </span>
  );
});
KeyboardShortcut.displayName = 'KeyboardShortcut';
